import { render } from "./ActionsRecommandations.vue?vue&type=template&id=ed3ef3d8&scoped=true"
import script from "./ActionsRecommandations.vue?vue&type=script&lang=js"
export * from "./ActionsRecommandations.vue?vue&type=script&lang=js"

import "./ActionsRecommandations.vue?vue&type=style&index=0&id=ed3ef3d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed3ef3d8"]])

export default __exports__